import { ActionTypes as ReduxActionTypes } from 'redux/lib/createStore';
import uuid from 'uuid/v4';

import { ActionTypes } from '../../actions/constants';

const generateUUID = () => uuid();

export const initialState = Object.freeze({
    searchQueryGuid: undefined,
    sessionId: '',
    trackingId: '',
});

export default function metadataReducer(state = initialState, action = {}) {
    switch (action.type) {
        case ReduxActionTypes.INIT:
            // we only want to regenerate the UUID for SSR page loads
            // once client side, the UUID should already be provided by window.__REDUX_STATE__
            return !state.searchQueryGuid ? {
                ...state,
                searchQueryGuid: generateUUID(),
            } : state;

        case ActionTypes.SEARCH_COMPLETED:
        case ActionTypes.SEARCH_FAILED:
            return {
                ...state,
                searchQueryGuid: generateUUID(),
            };

        case ActionTypes.SET_SESSION_ID:
            return {
                ...state,

                // the bsid has a timestamp at the end, deliminated with a _
                // data science asked us to remove that
                sessionId: action.sessionId.split('_')[0],
            };

        case ActionTypes.SET_TRACKING_ID:
            return {
                ...state,
                trackingId: action.trackingId,
            };

        default:
            return state;
    }
}
